import { DialogComponent } from '@theme/dialog';
  import { onAnimationEnd } from '@theme/utilities';

  class LPStoryDialog extends DialogComponent {
    async showStory(event) {
      const drawer = event?.target?.closest('header-drawer');
      if (drawer?.isOpen) {
        drawer.close();
        const panel = drawer.querySelector('.menu-drawer');
        if (panel) await onAnimationEnd(panel, undefined, { subtree: false });
        drawer.querySelector('summary')?.focus({ preventScroll: true });
      }
      if (this.isConnected) this.showDialog();
    }
  }
  if (!customElements.get('lp-story-dialog')) customElements.define('lp-story-dialog', LPStoryDialog);
